import styled from 'foundations-theming-specialty/utils';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Flex } from 'foundations-components/components/Flex';
import { PAGE_CONTENT_SPACING } from '../constants/layout';
import { ROUTES } from '../constants/routes';
import { Link as RouterLink } from 'quartz-routing/react-router';
import { useTicketListingsHeading } from '../hooks/useTicketListingsHeading';
import { useTicketDetailsParams } from '../hooks/useTicketDetailsParams';
import { formatTicketId } from '../utils/formatTicketId';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreadcrumbResetWrapper = styled.div.withConfig({
  displayName: "BreadcrumbContainer__BreadcrumbResetWrapper"
})(["> nav{margin:0;font-size:", ";}"], ({
  theme
}) => theme.typography['body-100'].fontSize);
export function BreadcrumbContainer() {
  const ticketListingsHeading = useTicketListingsHeading();
  const {
    ticketId
  } = useTicketDetailsParams();
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    paddingBlock: "500",
    paddingInline: PAGE_CONTENT_SPACING,
    children: /*#__PURE__*/_jsx(BreadcrumbResetWrapper, {
      children: /*#__PURE__*/_jsxs(Breadcrumbs, {
        flush: true,
        children: [/*#__PURE__*/_jsx(RouterLink, {
          to: ROUTES.root,
          children: ticketListingsHeading
        }), /*#__PURE__*/_jsx("span", {
          "data-test-id": "breadcrumb-ticket-id",
          children: formatTicketId(ticketId)
        })]
      })
    })
  });
}